import { FormikValues, useFormikContext } from 'formik';
import React from 'react';

import { Grupo, Rotulo } from '.';
import Ajuda from './Ajuda';

interface Props {
  ajuda?: string;
  altura?: string | number;
  name: string;
  rotulo?: string;
  semMargem?: boolean;
}

const CaixaDeTexto = ({
  ajuda,
  altura = '150px',
  name,
  rotulo,
  semMargem = false,
}: Props): React.ReactElement => {
  const { handleBlur, handleChange, getFieldMeta } =
    useFormikContext<FormikValues>();
  const { value, error, touched } = getFieldMeta(name);

  return (
    <Grupo semMargem={semMargem} emLinha={false}>
      <textarea
        name={name}
        className={`form-control ${
          error && touched && 'is-invalid'
        }`}
        onChange={handleChange}
        onBlur={handleBlur}
        value={(value as string) ?? ''}
        style={{ height: altura }}
        placeholder={rotulo}
      />
      <React.Fragment>
        {rotulo && <Rotulo name={name}>{rotulo}</Rotulo>}
      </React.Fragment>
      <React.Fragment>{ajuda && <Ajuda>{ajuda}</Ajuda>}</React.Fragment>
      <div className="invalid-tooltip">
        {error && touched && error}
      </div>
    </Grupo>
  );
};

export default CaixaDeTexto;
